import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import InlineModal from '../shared/InlineModal';
import SimpleList from '../shared/SimpleList';

export default function DisallowTagsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className="report-element default"
        >
            <SectionTitle title={title} />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result && result.disallow_tags && (
                    <div className="description-meta">
                        <InlineModal
                            openLabel="See results list"
                            modalTitle="Full list of disallow directives"
                            closeLabel="Close"
                        >
                            <SimpleList list={result.disallow_tags} />
                        </InlineModal>
                    </div>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
